
import HierarchySquare from "../../../assets/filled/HierarchySquare.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function HierarchySquareIcon({ className, dataTestid = "HierarchySquareIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <HierarchySquare data-testid={dataTestid} className={classes} {...rest} />
  );
}
